import axios from '../modules/AxiosInstance';
import Environment from '../modules/Environment';
import store from '../store';
import UriUtils from '../modules/UriUtils';
import { PAYIT_TENANT_USER_ID, } from '../modules/Constants';

const CitationsService = (() => {
  const service = {};
  const BASE_URL = `${Environment.getBaseURL()}`;

  const getCitationsBySearchCriteria = (criteria) => {
    const { authentication, } = store.getState().auth;
    const headers = {};
    headers.Authorization = authentication.token;
    headers[PAYIT_TENANT_USER_ID] = authentication.tenantUserId;

    const queryString = UriUtils.toQueryString(criteria);
    return axios.get(`${BASE_URL}/citations/citation-lookups/search${queryString}`, {
      headers,
    });
  };

  service.getServiceOfferings = () => {
    const { authentication, } = store.getState().auth;
    const headers = {};
    headers.Authorization = authentication.token;
    headers[PAYIT_TENANT_USER_ID] = authentication.tenantUserId;
    return axios.get(`${BASE_URL}/citations-offerings`, {
      headers,
    });
  };

  service.getCitationsBySearchCriteria = getCitationsBySearchCriteria;

  service.retryPayment = (txnId) => {
    const { authentication, } = store.getState().auth;
    const headers = {};
    headers.Authorization = authentication.token;
    headers[PAYIT_TENANT_USER_ID] = authentication.tenantUserId;

    return axios.post(`${BASE_URL}/citations/retry`, { txnId, }, { headers, });
  };

  return service;
})();

export default CitationsService;
